import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
    currentStep : 1,
    file: '',
    allColumns : [],
    rowData: [],
    matchedColumn: "",
    allEthnicityMapping : []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.MAP_ETHNICITY_NEXT_STEP: 
          return {...state,currentStep : state.currentStep + 1};
        case actionTypes.MAP_ETHNICITY_PREVIOUS_STEP :
          return {...state,currentStep : state.currentStep - 1};
        case actionTypes.MAP_ETHNICITY_UPLOAD_FILE_SUCCESS :
        return {...state, allColumns : action.val.columns, rowData : action.val.data, file: action.val.file};
        case actionTypes.MAP_ETHNICITY_MATCH_COLUMN_SUCCESS :
        return {...state, matchedColumn : action.val};
        case actionTypes.MAP_ETHNICITY_SAVE_ETHNICITY_MAPPING :
          return {...state, allEthnicityMapping : action.val};
        default:
          break;
    }
    return state;
}